import { computed, ref } from "@vue/composition-api";
import { MediaHeroItem, HeroListener } from "./model";

export const UseMediaHero = (() => {
  let _listener: HeroListener;
  const is_show = ref(false);
  const is_closed = computed(() => !is_show.value);

  const set_root_listener = (listener: HeroListener) => {
    _listener = listener;
  };

  const show = async (payload: MediaHeroItem) => {
    is_show.value = true;
    await _listener.on_show(payload);
    is_show.value = false;
  };

  return { set_root_listener, show, is_closed };
})();
